import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import theme from '@/styles/theme';
import Modal from '@/components/common/common-modal';
import { EAuthModalPage } from '@/store/types';
import { actions } from '@/store';
import Message from '@/constant/message';
import media from '@/styles/media';
import useSelectorUser from '@/hooks/use-selector-user';
import { Logo, MainDiv, Wrapper } from '../common/new-auth-layout';

export const Complete = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onClickStartButton = useCallback(() => {
    dispatch(actions.user.authModal.setCurrentPage(EAuthModalPage.SUCCESS));
  }, [dispatch]);

  return (
    <Modal show closeOnClickOverlay={false} backgroundOpacity={1}>
      <Wrapper>
        <MainDiv>
          <Main>
            <Logo src="/assets/images/common/STEAMuP-logo-v4.png" alt="logo" />
            <CompleteImg src="/assets/images/auth/complete-image.png" alt="complete" />
            <TextDiv>
              <Title>
                {t(Message.회원가입완료)}
                !
              </Title>
              <Text>
                {t(Message.스팀업회원이되신것을환영합니다)}
                회원가입 축하 기념으로
                <Emphasis>1,000P</Emphasis>
                적립해 드렸어요.
              </Text>
            </TextDiv>
            <ButtonContainer>
              <Button onClick={onClickStartButton}>
                {t(Message.스팀업시작하기)}
              </Button>
            </ButtonContainer>
          </Main>
        </MainDiv>
      </Wrapper>
    </Modal>

  );
};

export const CompletePasswordMobile = () => {
  const { gotoAuthLogin } = useSelectorUser('authModal');

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(actions.user.authModal.setCurrentPage(EAuthModalPage.INPUT_EMAIL));
    if (gotoAuthLogin) {
      gotoAuthLogin();
    }
  }, [dispatch, gotoAuthLogin]);

  return (
    <Modal show closeOnClickOverlay={false} backgroundOpacity={1}>
      <Wrapper>
        <MainDiv>
          <Main>
            <Logo src="/assets/images/common/STEAMuP-logo-v4.png" alt="logo" />
            <CompleteImg src="/assets/images/auth/complete-image.png" alt="complete" />
            <TextDiv>
              <Title>
                {t(Message.비밀번호재설정완료)}
                !
              </Title>
              <Text>
                {t(Message.새로운비밀번호설정이완료되었습니다)}
              </Text>
            </TextDiv>
            <ButtonContainer>
              <Button onClick={onClick}>
                {t(Message.스팀업시작하기)}
              </Button>
            </ButtonContainer>
          </Main>
        </MainDiv>
      </Wrapper>
    </Modal>
  );
};

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 57px auto;
`;

const CompleteImg = styled.img`
  width: 154px;
  height: 167px;
  padding-top: 103px;
`;

const TextDiv = styled.div`
  padding: 45px;
`;

const Title = styled.div`
  font-family: ${theme.fontFamily.bold};
  font-size: 30px;
  line-height: 36px;
  text-align: center;

  padding-bottom: 21px;
  ${media.xs`
    font-size: 26px;
    line-height: 31px;
  `}
`;

const Text = styled.div`
  font-family: ${theme.fontFamily.regular};
  font-size: 14px;
  line-height: 22px;
  text-align: center; 
`;

const Emphasis = styled.span`
  color: ${theme.color.purple};
  font-family: ${theme.fontFamily.regular};
`;

const ButtonContainer = styled.div`
  padding-top: 30px;
`;

const Button = styled.button`
  background: ${theme.color.purple};
  border: none;
  border-radius: 8px;
  padding: 16px 47px;
  font-family: ${theme.fontFamily.bold};
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  color: #FFFFFF;

  &:hover{
    opacity: 0.9;
  }
`;
